import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { createFileRoute } from '@tanstack/react-router';
import { Building2 } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/mspr')({
    staticData: {
        breadcrumb: {
            title: 'Material service providers',
            inactive: true,
        },
        modules: ['mspr'],
        permissions: ['msp:read', 'msp:read:own_handling_parties', 'msp:read:owner_without_handling_parties'],
        presentation: 'fullPage',
        ui: {
            icon: Building2,
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <MspRegister />
        </PageController>
    );
}

function MspRegister() {
    return (
        <Tabs
            // MSP exceptions needs `msp:read`; a user who sees only their own providers gets no tab bar.
            hideSingleTab
            items={[
                {
                    to: '/console/$orgId/mspr/service-providers/search',
                    label: 'Service providers',
                },
                {
                    to: '/console/$orgId/mspr/msp-exceptions',
                    label: 'MSP exceptions',
                },
            ]}
        />
    );
}
